import { Dispatch, Fragment, SetStateAction } from 'react'
import { useTranslation } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import HomChatAddIcon from '~/components/Icons/svgs/HomChatAddIcon'

export default function CompletedSessionAddCommentButton({
  displayCommentTextarea,
  setDisplayCommentTextarea,
}: {
  displayCommentTextarea: boolean
  setDisplayCommentTextarea: Dispatch<SetStateAction<boolean>>
}): React.ReactElement {
  const { t } = useTranslation('generics')

  if (displayCommentTextarea) {
    return <Fragment />
  }

  return (
    <button className="p-0.5 space-y-1 flex flex-col items-center" onClick={() => setDisplayCommentTextarea(true)}>
      <SVGIcon icon={HomChatAddIcon} size={30} />
      <span className="text-2.5 text-gray-light-fade">{t('addComment')}</span>
    </button>
  )
}
